<div class="restriction-details">
  <button type="button" class="btn btn-link d-flex align-items-center p-0" (click)="goBack()" [qcId]="'back-btn'">
    <i class="fa-solid fa-arrow-right"></i>
    <span>رجوع</span>
  </button>
  <div class="restriction-details-header d-flex flex-column flex-sm-row justify-content-between align-items-center">
    <h2 class="title text-black">
      قيد امتياز رقم #{{ franchise?.franchiseNo }}
    </h2>
    <div class="d-flex actions">
      <div *ngIf="franchise?.franchiseStatusId == franchiseStatus.Violated">
        <button type="button" class="btn btn-green mx-4" (click)="open('raiseViolation', true)">
          <span> رفع المخالفة</span>
        </button>
      </div>
      <div *ngIf="franchise?.franchiseStatusId == franchiseStatus.Suspended">
        <button type="button" class="btn btn-green mx-4" (click)="open('raiseSuspension', true)">
          <span> رفع الايقاف</span>
        </button>
      </div>
      <div ngbDropdown>
        <button type="button" class="btn DS btn-outline-green d-flex" id="dropdownBasic1" ngbDropdownToggle>
          <span> الاجراءات</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button *ngIf="checkPermission('Pages.Franchise.Default')" ngbDropdownItem
            (click)="printFranchiseCertificate(franchise?.franchiseNo)">
            <i class="fa-regular fa-file-certificate"></i>
            <span> طباعة الشهادة </span>
          </button>

          <div *ngIf="franchise?.franchiseStatusId == franchiseStatus.Approved">
            <button *ngIf="checkPermission('Pages.Franchise.Violation')" (click)="open('warningCancellation')"
              ngbDropdownItem>
              <i class="fa-regular fa-ban"></i>
              <span> مخالفة القيد </span>
            </button>
            <button *ngIf="checkPermission('Pages.Franchise.TurnOff')" (click)="open('restrictionStop')"
              ngbDropdownItem>
              <i class="fa-regular fa-circle-stop"></i>
              <span> ايقاف القيد </span>
            </button>
            <button *ngIf="checkPermission('Pages.Franchise.Cancelation')" (click)="open('restrictionCancellation')"
              ngbDropdownItem>
              <i class="fa-regular fa-trash"></i>
              <span> الغاء القيد </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="restrictionCard">
    <div class="row">
      <div class="col-12 col-md-2">
        <div [qcId]="'fromcrname-title-div'" class="restrictionCard-label text-grey">
          سجل المانح
        </div>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCRName }}
        </div>
      </div>
      <div class="col-12 col-md-2">
        <div [qcId]="'tocrname-title-div'" class="restrictionCard-label text-grey">
          سجل صاحب الامتياز
        </div>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.toCRName }}
        </div>
      </div>
      <div class="col-12 col-md-2">
        <div [qcId]="'startdate-title-div'" class="restrictionCard-label text-grey">
          تاريخ بداية الامتياز
        </div>
        <div class="restrictionCard-title1 text-black">
          <img src="./assets/images/post.svg" />
          {{ franchise?.franchiseStartFormatted }}
        </div>
      </div>
      <div class="col-12 col-md-2">
        <div [qcId]="'enddate-title-div'" class="restrictionCard-label text-grey">
          تاريخ نهاية الامتياز
        </div>
        <div class="restrictionCard-title1 text-black">
          <img src="./assets/images/post.svg" />
          {{ franchise?.franchiseEndFormatted }}
        </div>
      </div>
      <div class="col-12 col-md-2">
        <div [qcId]="'franchisetype-title-div'" class="restrictionCard-label text-grey">
          نوع الامتياز
        </div>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.franchiseTypeName }}
        </div>
      </div>

      <div class="col-12 col-md-2">
        <div [qcId]="'franchisestatus-title-div'" class="restrictionCard-label text-grey">
          حالة الامتياز
        </div>
        <div class="restrictionCard-title1 text-black">
          <ng-container [ngSwitch]="franchise?.franchiseStatusId">
            <ng-container *ngSwitchCase="franchiseStatus.Approved">
              <span [qcId]="'status-span'" class="badge active">نشط</span>
            </ng-container>
            <ng-container *ngSwitchCase="franchiseStatus.Expired">
              <span [qcId]="'status-span'" class="badge cancelled">منتهي</span>
            </ng-container>
            <ng-container *ngSwitchCase="franchiseStatus.Suspended">
              <span [qcId]="'status-span'" class="badge in-active">موقوف</span>
            </ng-container>
            <ng-container *ngSwitchCase="franchiseStatus.Violated">
              <span [qcId]="'status-span'" class="badge warning">مخالف</span>
            </ng-container>
            <ng-container *ngSwitchCase="franchiseStatus.Canceled">
              <span [qcId]="'status-span'" class="badge cancelled">ملغي</span>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- violated -->
  <app-violated-section [franchise]="franchise" *ngIf="franchise?.franchiseStatusId == franchiseStatus.Violated">
  </app-violated-section>
  <!--End-->
  <!-- suspended -->
  <app-suspended-section [franchise]="franchise" *ngIf="franchise?.franchiseStatusId == franchiseStatus.Suspended">
  </app-suspended-section>
  <!--End-->
  <!-- suspended -->
  <app-cancelled-section [franchise]="franchise" *ngIf="franchise?.franchiseStatusId == franchiseStatus.Canceled">
  </app-cancelled-section>
  <!--End-->
  <div class="restrictionCard">
    <h2 class="restrictionCard-title1 text-black line-bottom">
      معلومات مانح الامتياز
    </h2>
    <div class="row">
      <div class="col-md-4">
        <h2 [qcId]="'fromcrname1-title-div'" class="restrictionCard-label text-grey mb-1">
          إسم السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCRName }}
        </div>
      </div>
      <div class="col-md-4" *ngIf="isInternal">
        <h2 [qcId]="'fromcrnum-title-div'" class="restrictionCard-label text-grey mb-1">
          الرقم الوطنى الموحد للمنشأة
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCRNumber }}
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isInternal">
        <h2 [qcId]="'fromcrnum-title-div'" class="restrictionCard-label text-grey mb-1">
          رقم السجل التجارى
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCRNumber }}
        </div>
      </div>
      <!-- <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">مالك السجل</h2>
        <div class="restrictionCard-title1 text-black">نايف علي جميل</div>
      </div> -->
      <div class="col-md-4" *ngIf="franchise?.fromCRPeriod">
        <h2 [qcId]="'fromcrperiod-title-div'" class="restrictionCard-label text-grey mb-1">
          مدة السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCRPeriod }}
        </div>
      </div>

      <div class="col-md-4">
        <div class="restrictionCard-label">تاريخ اصدار السجل التجاري</div>
        <div *ngIf="franchise?.fromCRIssueDate" class="restrictionCard-title2">
          {{ franchise?.fromCRIssueDate }}
        </div>
        <div *ngIf="!franchise?.fromCRIssueDate" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="restrictionCard-label">تاريخ انتهاء السجل التجاري</div>
        <div *ngIf="franchise?.fromCRExpireDate" class="restrictionCard-title2">
          {{ franchise?.fromCRExpireDate }}
        </div>
        <div *ngIf="!franchise?.fromCRExpireDate" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>

      <div class="col-md-4" *ngIf="franchise?.countryName">
        <h2 class="restrictionCard-label text-grey mb-1">الدولة</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.countryName }}
        </div>
      </div>

      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">رقم جوال المانح</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.donorTelephoneNumber }}
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">البريد الإلكتروني</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.donorEmail }}
        </div>
      </div>
      <div class="col-md-4" *ngIf="franchise?.fromCREntityWebsite">
        <h2 class="restrictionCard-label text-grey mb-1">الموقع الالكتروني</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.fromCREntityWebsite }}
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">الية المنح</h2>
        <div class="restrictionCard-title1 text-black"
          *ngIf="franchise?.referenceTypeId === this.referenceTypeEnum.CrName">
          الاسم التجاري
        </div>
        <div class="restrictionCard-title1 text-black" *ngIf="
            franchise?.referenceTypeId === this.referenceTypeEnum.Trademark
          ">
          العلامة التجارية
        </div>
      </div>
      <div class="col-md-4" *ngIf="franchise?.referenceTypeId === this.referenceTypeEnum.Trademark">
        <h2 class="restrictionCard-label text-grey mb-1">رقم العلامة</h2>
        <div class="restrictionCard-logo">
          {{ franchise?.trademarkInfoDto?.id }}
          <!-- <img src="./assets/images/trade-logo.svg" alt="" /> -->
        </div>
      </div>
      <div class="col-md-4" *ngIf="franchise?.referenceTypeId === this.referenceTypeEnum.Trademark">
        <h2 class="restrictionCard-label text-grey mb-1">اسم العلامة (عربي)</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.trademarkInfoDto?.arabicName }}
        </div>
      </div>
      <div class="col-md-4" *ngIf="franchise?.referenceTypeId === this.referenceTypeEnum.Trademark">
        <h2 class="restrictionCard-label text-grey mb-1">
          اسم العلامة (انجليزي)
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.trademarkInfoDto?.englishName }}
        </div>
      </div>

      <div class="col-md-12 mt-3">
        <h2 class="restrictionCard-label text-grey mb-1">
          عنوان السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          <div *ngIf="franchise?.donorAddress != null">
            {{ "Global.StreetName" | translate }}
            {{ franchise?.donorAddress?.streetName }} -
            {{ "Global.DistrictName" | translate }}
            {{ franchise?.donorAddress?.districtName }} -
            {{ "Global.CityName" | translate }}
            {{ franchise?.donorAddress?.cityName }} -
            {{ "Global.BuildingNo" | translate }}
            {{ franchise?.donorAddress?.buildingNo }} -
            {{ "Global.UnitNo" | translate }}
            {{ franchise?.donorAddress?.unitNo }} -
            {{ "Global.PostalCode" | translate }}
            {{ franchise?.donorAddress?.postalCode }} -
            {{ "Global.ZipCode" | translate }}
            {{ franchise?.donorAddress?.zipCode }}
          </div>
          <div *ngIf="!(franchise?.donorAddress != null)">
            {{ "Global.NoResult" | translate }}
          </div>
        </div>
      </div>


    </div>
    <div *ngIf="donorAttachments && donorAttachments.length > 0" class="restrictionCard-label mt-5">
      {{ "Global.Attachments" | translate }}
    </div>
    <div class="row" *ngIf="donorAttachments && donorAttachments.length > 0">

      <div class="col-12 col-md-3" *ngFor="let item of donorAttachments">
        <div class="file-container">
          <div class="file-container-info d-flex">
            <div class="file-icon">
              <img src="./assets/images/pdf-icon.svg" />
            </div>
            <div [qcId]="'attachment-div'" class="file-info">
              <h6 class="file-name">{{ item.fileName }}</h6>
              <h6 class="file-type">{{ item.attachmentTypeName }}</h6>
            </div>
          </div>
          <div class="icons">
            <!-- <div class="icon d-flex justify-content-center align-items-center preview">
              <i class="fa-light fa-eye cursor-pointer"></i>
            </div> -->
            <div class="icon d-flex justify-content-center align-items-center download"
              (click)="downloadAttachment(item.publicId, item.fileName)">
              <i class="fa-sharp fa-regular fa-arrow-down-to-line cursor-pointer"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="border-line" />
    <h2 class="restrictionCard-title1 text-black line-bottom">
      معلومات صاحب الامتياز
    </h2>
    <div class="row">
      <div class="col-md-4">
        <h2 [qcId]="'tocrname1-title-div'" class="restrictionCard-label text-grey mb-1">
          اسم السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.toCRName }}
        </div>
      </div>
      <div class="col-md-4">
        <h2 [qcId]="'tocrnum-title-div'" class="restrictionCard-label text-grey mb-1">
          الرقم الوطنى الموحد للمنشأة
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.toCRNumber }}
        </div>
      </div>
      <!-- <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">مالك السجل</h2>
        <div class="restrictionCard-title1 text-black">نايف علي جميل</div>
      </div> -->
      <div class="col-md-4">
        <h2 [qcId]="'tocrperiod-title-div'" class="restrictionCard-label text-grey mb-1">
          مدة السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.toCRPeriod }}
        </div>
      </div>
      <!-- start -->
      <div class="col-md-4">
        <div class="restrictionCard-label">تاريخ اصدار السجل التجاري</div>
        <div *ngIf="franchise?.toCRIssueDate" class="restrictionCard-title2">
          {{ franchise?.toCRIssueDate }}
        </div>
        <div *ngIf="!franchise?.toCRIssueDate" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="restrictionCard-label">تاريخ انتهاء السجل التجاري</div>
        <div *ngIf="franchise?.toCRExpireDate" class="restrictionCard-title2">
          {{ franchise?.toCRExpireDate }}
        </div>
        <div *ngIf="!franchise?.toCRExpireDate" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="restrictionCard-label">نوع السجل التجاري</div>
        <div *ngIf="franchise?.businessTypeName" class="restrictionCard-title2">
          {{ franchise?.businessTypeName }}
        </div>
        <div *ngIf="!franchise?.businessTypeName" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="restrictionCard-label">حالة السجل التجاري</div>
        <div *ngIf="franchise?.crStatusMessage" class="restrictionCard-title2">
          {{ franchise?.crStatusMessage }}
        </div>
        <div *ngIf="!franchise?.crStatusMessage" class="restrictionCard-title1 text-black">
          {{ "Global.NoResult" | translate }}
        </div>
      </div>
      <div class="col-md-12 mt-3">
        <h2 class="restrictionCard-label text-grey mb-1">نشاط السجل التجاري</h2>
        <div class="restrictionCard-title1 text-black">
          <div *ngIf="franchise?.activities">
            {{ franchise?.activities }}
          </div>
          <div *ngIf="!franchise?.activities">
            {{ "Global.NoResult" | translate }}
          </div>
        </div>
      </div>
      <!-- end -->
      <div class="col-md-12 mt-3">
        <h2 class="restrictionCard-label text-grey mb-1">
          عنوان السجل التجاري
        </h2>
        <div class="restrictionCard-title1 text-black">
          <div *ngIf="franchise?.grantedAddress != null">
            {{ "Global.StreetName" | translate }}
            {{ franchise?.grantedAddress?.streetName }} -
            {{ "Global.DistrictName" | translate }}
            {{ franchise?.grantedAddress?.districtName }} -
            {{ "Global.CityName" | translate }}
            {{ franchise?.grantedAddress?.cityName }} -
            {{ "Global.BuildingNo" | translate }}
            {{ franchise?.grantedAddress?.buildingNo }} -
            {{ "Global.UnitNo" | translate }}
            {{ franchise?.grantedAddress?.unitNo }} -
            {{ "Global.PostalCode" | translate }}
            {{ franchise?.grantedAddress?.postalCode }} -
            {{ "Global.ZipCode" | translate }}
            {{ franchise?.grantedAddress?.zipCode }}
          </div>
          <div *ngIf="!(franchise?.grantedAddress != null)">
            {{ "Global.NoResult" | translate }}
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">
          رقم جوال صاحب الامتياز
        </h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.ownerTelephoneNumber }}
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">البريد الالكتروني</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchise?.ownerEmail }}
        </div>
      </div>
    </div>
    <hr class="border-line" />
    <h2 class="restrictionCard-title1 text-black line-bottom">
      معلومات الامتياز
    </h2>
    <div class="row">
      <div class="col-12 col-md-3" *ngFor="let item of franchiseAttachments">
        <div class="file-container">
          <div class="file-container-info d-flex">
            <div class="file-icon">
              <img src="./assets/images/pdf-icon.svg" />
            </div>
            <div [qcId]="'attachment-div'" class="file-info">
              <h6 class="file-name">{{ item.fileName }}</h6>
              <h6 class="file-type">{{ item.attachmentTypeName }}</h6>
            </div>
          </div>
          <div class="icons">
            <!-- <div class="icon d-flex justify-content-center align-items-center preview">
              <i class="fa-light fa-eye cursor-pointer"></i>
            </div> -->
            <div class="icon d-flex justify-content-center align-items-center download"
              (click)="downloadAttachment(item.publicId, item.fileName)">
              <i class="fa-sharp fa-regular fa-arrow-down-to-line cursor-pointer"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="trade-activites" *ngIf="franchise?.crActivities.length > 0">
      <h2 class="restrictionCard-label text-grey mb-1">الانشطة التجارية</h2>
      <div class="restrictionCard-title1 text-black">
        <ul>
          <li class="circle-list-item" *ngFor="let activity of franchise?.crActivities">
            {{ activity.activityName }}
          </li>
        </ul>
      </div>
    </div>
    <hr class="border-dashed" />
    <div [qcId]="'description-div'" class="trade-description">
      <h2 class="restrictionCard-label text-grey mb-1">
        وصف اعمال الامتياز الممارسة
      </h2>
      <div class="restrictionCard-title1 text-black">
        {{ franchise?.franchiseWorkDescription }}
      </div>
    </div>
    <hr class="border-dashed" />
    <h2 [qcId]="'franchisetype1-title-div'" class="restrictionCard-label text-grey mb-1">
      نوع الامتياز
    </h2>
    <div class="restrictionCard-title1 text-black">
      <p [qcId]="'franchisetypename-div'" class="circle-list-item">
        {{ franchise?.franchiseTypeName }}
      </p>
    </div>
    <div class="regions">
      <div class="row">
        <div class="col-md-3">
          <h2 [qcId]="'region-title-div'" class="restrictionCard-label text-grey mb-1">
            منطقة ممارسة الامتياز
          </h2>
          <div class="restrictionCard-badge text-black">
            <div class="d-flex align-items-center" *ngFor="let item of franchise?.citiesAndRegions">
              <i class="fa-solid fa-check"></i>
              <span class="region text-bold">{{ item.region }}</span>
              <span>{{ item.cities }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3" *ngIf="franchise?.districtName">
          <h2 class="restrictionCard-label text-grey mb-1">
            حي ممارسة الامتياز
          </h2>
          <div class="restrictionCard-badge text-black">
            <span> {{ franchise?.districtName }}</span>
          </div>
        </div>
      </div>
    </div>
    <hr class="border-dashed" />
    <div class="dates">
      <div class="row">
        <div class="col-md-3">
          <h2 class="restrictionCard-label text-grey mb-1">
            تاريخ بداية الامتياز
          </h2>
          <div class="restrictionCard-title1 text-black">
            {{ franchise?.franchiseStartFormatted }}
          </div>
        </div>
        <div class="col-md-3">
          <h2 class="restrictionCard-label text-grey mb-1">
            تاريخ نهاية الامتياز
          </h2>
          <div class="restrictionCard-title1 text-black">
            {{ franchise?.franchiseEndFormatted }}
          </div>
        </div>
        <div class="col-md-3">
          <h2 class="restrictionCard-label text-grey mb-1">مدة الامتياز</h2>
          <div class="restrictionCard-title1 text-black">
            {{ franchise?.franchisePeriod }}
          </div>
        </div>
        <hr class="border-line" />
      </div>
      <hr class="border-line" />
    </div>
    <div class="restrictionCard-moreInfo">
      <div class="row">
        <div class="col-md-2">
          <div class="restrictionCard-badge text-black">
            <div style="cursor:pointer;"
              title="اجمالي عدد وحدات الامتياز التجاري التي منحتها العلامة لكافة أصحاب الامتياز وتشمل عدد وحدات الامتياز القائمة للامتيازات الرئيسية            "
              class="d-flex">
              <span class="restrictionInfo-number text-bold text-green">
                {{ franchise?.activeCrCount }}</span>
              <span>اجمالي عدد الامتيازات الممنوحة للعلامة</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="restrictionCard-badge text-black">
            <div style="cursor:pointer;"
              title="عدد وحدات الامتياز التجاري المتفق عليها ضمن الاتفاقية الحالية  للعمل على تشغيلها" class="d-flex">
              <span class="restrictionInfo-number text-bold text-green">{{
                franchise?.portsCount
                }}</span>
              <span>عدد وحدات الامتياز الممنوحة ضمن الاتفاقية الحالية</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="restrictionCard-badge text-black">
            <div class="d-flex">
              <span class="restrictionInfo-number text-bold text-green">{{
                franchise?.closedPortsCount
                }}</span>
              <span> المنافذ المغلقة خلال (5-10) سنوات الماضية</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="restrictionCard-badge text-black">
            <div style="cursor:pointer;"
              title="هي عدد الوحدات المستهدف منحها لأصحاب امتياز يتم التفاوض معهم  ولم يتم اعتمادها أو توقيعها حتى اللحظة الحالية."
              class="d-flex">
              <span class="restrictionInfo-number text-bold text-green">
                {{ franchise?.franchisesOrPortsCount }}
              </span>
              <span>عدد وحدات الامتياز المستهدف منحها(ويقصد فيها المخطط منحها لأصحاب امتياز محتملين)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>